import Checkbox from '../../../common/components/Checkbox.js'
import {updateForm, useForm} from '../../../store.js'
import FormListItem from '../Common/FormListItem.js'
import Warehouses from './Warehouses.js'
import {
  BIGCOMMERCE,
  CUSTOM_INTEGRATION,
  ETSY,
  SHIP_STATION,
  SHOPIFY,
} from '../../../common/constants/CartVendorOptions.js'
import NumberInput from '../../../common/components/Form/NumberInput.js'
import DatePicker from '../../../common/components/DatePicker.js'

/**
 * A component to collect all the sync settings. All shippers have this component
 *
 * @param {Object} props
 * @param {String} [props.className]
 * @param {String} props.formName
 * @returns {React.ReactNode}
 */
export default function SyncConfig({className, formName}) {
  const {
    default_product_sync,
    default_min_export_qty,
    import_zero_qty_lines,
    syncs_shipped_orders,
    import_min_order_placed_date,
    vendor,
  } = useForm(formName)

  return (
    <FormListItem className={className}>
      <p className="fs-00 lh-md margin-bottom-10">
        <strong>Sync Settings for this Sales Channel</strong>
      </p>
      <Checkbox
        labelClassName="flex margin-bottom-10"
        id="default_product_sync"
        label="Import New Products with Inventory Sync Enabled"
        checked={default_product_sync}
        onChange={(checked) =>
          updateForm(formName, {default_product_sync: checked})
        }
      />
      <Checkbox
        labelClassName="flex margin-bottom-15"
        id="import_zero_qty_lines"
        label="Import Zero Quantity Lines"
        checked={import_zero_qty_lines}
        onChange={(checked) =>
          updateForm(formName, {import_zero_qty_lines: checked})
        }
        helpLink="https://support.ordoro.com/how-do-i-sync-order-line-revisions-in-ordoro/#zeroqty"
        helpTitle="Learn more about importing zero quantity lines"
      />
      {[SHOPIFY, ETSY, BIGCOMMERCE].includes(vendor) && (
        <Checkbox
          labelClassName="flex margin-bottom-15"
          id="syncs_shipped_orders"
          label="Mark orders as shipped if order is shipped in Sales Channel"
          checked={syncs_shipped_orders}
          onChange={(checked) =>
            updateForm(formName, {syncs_shipped_orders: checked})
          }
        />
      )}
      <NumberInput
        id="default_min_export_qty"
        label="Default Minimum Export Quantity"
        containerClassName="margin-bottom-15"
        value={default_min_export_qty}
        onChange={(value) =>
          updateForm(formName, {default_min_export_qty: value})
        }
      />
      <div className="wrap--datepicker-md">
        <DatePicker
          className="margin-bottom-15"
          id="import_min_order_placed_date"
          label="Ignore Orders Placed Before this Date:"
          selected={import_min_order_placed_date}
          onChange={(import_min_order_placed_date) =>
            updateForm(formName, {import_min_order_placed_date})
          }
        />
      </div>
      {![SHIP_STATION, CUSTOM_INTEGRATION].includes(vendor) && (
        <Warehouses formName={formName} />
      )}
    </FormListItem>
  )
}
